import { useFilters } from '@domain-group/react-hooks'

import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAgencyProviderPackages from '@hooks/useAgencyProviderPackages'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import AgencyPackageListItem from './AgencyProviderPackageListItem'

const requestOptions = {
  include_agency_provider_package_provider_package: true,
  include_provider_package_provider: true,
}

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }
  const boxProps = { marginBottom: 'large' }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'package_title',
      label: 'Filter by Package Title',
    },
  ]
}

interface AgencyProviderPackagesProps {
  agencyId: number,
  providerId: number,
}
const AgencyProviderPackages = (props: AgencyProviderPackagesProps) => {
  const { agencyId, providerId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const agencyPackagesPayload = useAgencyProviderPackages({
    filters: {
      agency_id: agencyId,
      provider_id: providerId,
      ...pageFilters,
    },
    performHttpRequests: !!agencyId && !!providerId,
    requestOptions,
    sortKey: 'provider_package_id',
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyProviderPackagesCount,
    filteredAgencyProviderPackages,
    hasFilteredAgencyProviderPackages,
    loading,
  } = agencyPackagesPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-packages' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Packages"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyProviderPackages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Packages present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyProviderPackages && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection maxHeight={600}>
            {filteredAgencyProviderPackages.map(agencyProviderPackage => (
              <AgencyPackageListItem
                agencyProviderPackage={agencyProviderPackage}
                key={agencyProviderPackage.id}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyProviderPackagesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default AgencyProviderPackages
